import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "../rootReducer";

const estimationState = (state: AppState) => state.estimation;

const files = createSelector(estimationState, (state) => state.files);
const notes = createSelector(estimationState, (state) => state.notes);
const links = createSelector(estimationState, (state) => state.links);
const isLoading = createSelector(estimationState, (state) => state.isLoading);
const isUpdateScopeNoteLoading = createSelector(estimationState, (state) => state.isUpdateScopeNoteLoading);
const isUpdateLineItemLoading = createSelector(estimationState, (state) => state.isUpdateLineItemLoading);
const isPdfLoading = createSelector(estimationState, (state) => state.isPdfLoading);
const estimation = createSelector(estimationState, (state) => state.estimation);
const currentRoom = createSelector(estimationState, (state) => state.currentRoom);
const fixedMapping = createSelector(estimationState, (state) => state.fixedMapping);
const lineItemDetail = createSelector(estimationState, (state) => state.lineItemDetail);
const missingMappings = createSelector(estimationState, (state) => state.missingMappings);
const estimationDetail = createSelector(estimationState, (state) => state.estimationDetail);
const fullPageImagePath = createSelector(estimationState, (state) => state.fullPageImagePath);
const estimationCreated = createSelector(estimationState, (state) => state.estimationCreated);
const selectedFiles = createSelector(estimationState, (state) => state.selectedFiles);
const region = createSelector(estimationState, (state) => state.region);
const previewCategory = createSelector(estimationState, (state) => state.previewCategory);
const allCurrentViewPages = createSelector(estimationState, (state) => state.allCurrentViewPages);
const exportedToXactimate = createSelector(estimationState, (state) => state.exportedToXactimate);
const rightSidebarCurrentTab = createSelector(estimationState, (state) => state.rightSidebarCurrentTab);
const showMissingMappingModal = createSelector(estimationState, (state) => state.showMissingMappingModal);
const lineItemXactimateMapping = createSelector(estimationState, (state) => state.lineItemXactimateMapping || []);
const uploadedFilesPropertiesCreated = createSelector(estimationState, (state) => state.uploadedFilesPropertiesCreated);
const selectedLineItems = createSelector(estimationState, (state) => state.selectedLineItems || []);
const hasSelection = createSelector(selectedLineItems, (items) => items.length > 0);
const knownLineItemComponentKeys = createSelector(estimationState, (state) => state.knownLineItemComponentKeys || []);

export const estimationSelector = {
  files,
  notes,
  links,
  region,
  isLoading,
  isPdfLoading,
  estimation,
  currentRoom,
  fixedMapping,
  selectedFiles,
  lineItemDetail,
  missingMappings,
  estimationDetail,
  fullPageImagePath,
  estimationCreated,
  allCurrentViewPages,
  rightSidebarCurrentTab,
  showMissingMappingModal,
  lineItemXactimateMapping,
  previewCategory,
  uploadedFilesPropertiesCreated,
  exportedToXactimate,
  selectedLineItems,
  hasSelection,
  isUpdateScopeNoteLoading,
  isUpdateLineItemLoading,
  knownLineItemComponentKeys,
};
